<template>
  <div class="page">
    <mobileHeader
      title="邀请好友"
      rightType="share"
      fColor="#000000"
      bg="#ffffff"
      :shopId="shopId"
    />
    <div class="qrcode-bg">
      <img v-if="codeImage" :src="codeImage" class="qrcode-img" alt="" @error="onImgError" />
    </div>
    <div class="content">
      <div class="title">奖励规则说明:</div>
      <div class="text">
        邀请未注册客户扫码或识别你的二维码注册优气宝并购买商品，你将获得 <span>{{reward.amount && (reward.amount + '元现金/')}}{{reward.commission && (reward.commission + '%的销售额提成/')}}{{reward.gift_name && (reward.gift_name + '的礼品')}} </span> 的奖励。
      </div>
      <div class="title">操作流程:</div>
      <div class="text">
        <p>1、点击右上角分享二维码给好友，或截图本页面保存发送给好友。</p>
        <p>2、新客户使用微信识别二维码、或直接扫描二维码，按照步骤完成注册、下单。</p>
        <p>3、当你推荐的新客户首单签收后你将于24小时内获得奖励。</p>
      </div>
    </div>
    
    <van-popup v-model="selectShop" :style="{ width: '86%' }" :close-on-click-overlay="false" @click-overlay="clickOverlay">
      <div class="shop-list">
        <div class="shop-item" v-for="(item, index) in shopList" :key="index" @click="touchShopItem(item)">{{item.name}}</div>
      </div>
      
    </van-popup>
  </div>
</template>

<script>
import mobileHeader from "@/components/mobileHeader";
import {getCodeImage, rewardRule, myDetail} from "@/api/inviteFriends"
import { Toast } from 'vant';

export default {
  data() {
    return {
      codeImage: "",
      reward: {},
      selectShop: false,
      shopList: [],
      shopId: null
    };
  },
  components: {
    mobileHeader,
  },
  async created() {
    if(this.$store.state.userRole == 1){
      this.shopId = this.$store.state.userShopID
      this.getCodeImage()
    }else{
      this.selectShop = true
      this.getShopList()
    }
    this.rewardRule()
  },
  methods: {
    async getShopList(){
      const {code,data,msg} = await myDetail()
      if(code != 200)return Toast({message: msg, duration: 500})
      console.log(data.shops,"data")
      if(data.shops.length != 1)return this.shopList = data.shops
      this.selectShop = false
      this.shopId = data.shops[0].id
      console.log(this.shopId, "仅有一个门店")
      this.getCodeImage()
    },
    clickOverlay(){
      Toast({message: "请选择门店", duration: 500})
    },
    touchShopItem({id}){
      this.shopId = id
      this.selectShop = false
      this.getCodeImage()
    },
    async getCodeImage(){
      const {code,data,msg} = await getCodeImage({shop_id: this.shopId})
      code == 200 ? (this.codeImage = data) : Toast({message: msg, duration: 500})
    },
    async rewardRule(){
      const {code,data,msg} = await rewardRule()
      code == 200 ? (this.reward = data) : Toast({message: msg, duration: 500})
    },
    onImgError(e){
      console.warn('[myQrcode] 二维码图片加载失败:', this.codeImage, e)
      Toast({message: '二维码加载失败，请稍后重试', duration: 1500})
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .header-title{
  font-size: 5vw;
}
.page {
  background: #f7f7f7;
  min-height: 100vh;
  height: fit-content;
  .qrcode-bg {
    height: 106vw;
    width: 100%;
    position: relative;
    background-image: url("../../assets/images/yaoqing@2x.png");
    background-size: 100% 100%;
    .qrcode-img {
      position: absolute;
      left: 27%;
      top: 34vw;
      width: 46vw;
      height: 46vw;
      object-fit: cover;
    }
  }
  .content{
    padding: 2vw 8.2vw;
    .title{
      font-size: 5vw;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #6A22F4;
      line-height: 5vw;
      padding-top: 6.7vw;
    }
    .text{
      font-size: 3.3vw;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #666666;
      line-height: 5vw;
      padding-top: 2.8vw;
      span{
        color: #6A22F4;
      }
      p{
        margin: 1.4vw 0;
      }
    }

  }
}
::v-deep .van-popup{
  background: transparent;
}
.shop-list{
  max-height: 170px;
  overflow: auto;
  background: white;
  border-radius: 10px;
  .shop-item{
    line-height: 50px;
    font-size: 24px;
    text-align: center;

  }
  .shop-item + .shop-item{
    border-top: 1px solid #ccc;
  }
  .shop-item:hover{
    background: #666666;
  }
}
</style>